import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IoEarth } from 'react-icons/io5'

import { useCurrencySelector } from '@/shared/hooks/useCurrencySelector'
import { useLanguageSelector } from '@/shared/hooks/useLanguageSelector'

import { Combobox } from '../FormComponents'
import { Popups } from '../Popups'
import { Button } from '../ui/button'

export const applicationLocale: 'en-US' | 'es-ES' | 'pt-BR' | undefined =
  localStorage.getItem('selectedLanguage') as
    | 'en-US'
    | 'es-ES'
    | 'pt-BR'
    | undefined

export function CurrencyLangToggle({ open }: { open: boolean }) {
  const { t } = useTranslation()
  const {
    selectedCurrency,
    tempCurrency,
    formattedCurrencies,
    handleTempChange: handleCurrencyTempChange,
    saveCurrency,
  } = useCurrencySelector('BRL')

  const {
    selectedLanguage,
    tempLanguage,
    formattedLanguages,
    handleTempChange: handleLanguageTempChange,
    saveLanguage,
  } = useLanguageSelector()

  const [openLangAndCurrency, setOpenLangAndCurrency] = useState(false)

  const handleSave = () => {
    saveLanguage()
    saveCurrency()
    setOpenLangAndCurrency(false)
  }

  const handleClose = () => {
    setOpenLangAndCurrency(false)
  }

  return (
    <>
      <div>
        <Button
          variant="outline"
          className={`w-full ${open && 'justify-start'} bg-transparent hover:bg-white/10 duration-200`}
          onClick={() => setOpenLangAndCurrency(!openLangAndCurrency)}
        >
          <IoEarth className="size-4 text-white flex-shrink-0" />

          {open && (
            <span className="ml-2 text-white text-sm">
              {selectedLanguage?.split('-')[0].toUpperCase()} -{' '}
              {selectedCurrency}
            </span>
          )}
        </Button>
      </div>

      <Popups.Modal.Root
        open={openLangAndCurrency}
        onOpenChange={res => setOpenLangAndCurrency(res)}
      >
        <Popups.Modal.Content
          position="center"
          closeButton={false}
          className="max-w-md h-80 px-4 py-3"
        >
          <p className="font-semibold text-lg">{t('configLangAndCurrency')}</p>
          <Combobox
            label={t('lang')}
            placeholder={t('lang')}
            items={formattedLanguages}
            originalItems={formattedLanguages}
            value={tempLanguage}
            onValueChange={handleLanguageTempChange}
            labelProperty="label"
            valueProperty="value"
          />
          <Combobox
            label={t('currency')}
            placeholder={t('currency')}
            items={formattedCurrencies}
            originalItems={formattedCurrencies}
            value={tempCurrency}
            onValueChange={handleCurrencyTempChange}
            labelProperty="label"
            valueProperty="value"
            maxHeight="6rem"
          />
          <Button className="capitalize" onClick={handleSave}>
            {t('save')}
          </Button>
          <Button className="capitalize" variant="ghost" onClick={handleClose}>
            {t('close')}
          </Button>
        </Popups.Modal.Content>
      </Popups.Modal.Root>
    </>
  )
}
